import ViewBase from '../views/view-base.view';
import {getHelpDeskInfo} from '../models/profile.model'

export default function RecipientListView(vnode) {

  ViewBase.call(this);

  let list = [];

  const getData = () => {
    this.showLoading();
    getHelpDeskInfo()
      .then((result) => {
        list = result;
      })
      .catch((error) => {
        this.handleError(error)
      })
      .finally(() => {
        this.hideLoading();
      })
  }

  return {
    oninit: function (vnode) {
      getData()
    },
    view: (vnode) => {
      return [
        m('.card',
          m('.card-body',
       
            m(".table-responsive",
              m("table.table", [
                m("thead",
                  m("tr.align-middle", [
                    m("th", { "scope": "col" }, this.getText("LT00000239", "BU")),
                    m("th", { "scope": "col" }, this.getText("LT00000190", "Email")),
                    m("th", { "scope": "col" }, this.getText('LT00000247', 'Contact Number')),
                    m("th", { "scope": "col" }, this.getText("LT00008158", "Support Hours")),
                    m("th", { "scope": "col" }, this.getText('LT00000152', 'Remarks'))

                  ])
                ),
                m("tbody",
                  list.length == 0 &&
                  m("tr", { "class": "align-middle" },
                    m("td", { "colspan": "7" }, this.getText("EM00000141", "No records found."))
                  ),
                  list.map(gc => [
                    m("tr", [
                      m("td", gc.bu),
                      m("td", gc.email),
                      m("td", gc.contactNo),
                      m("td", gc.operatingHour),
                      m("td", gc.remarks)
                    ])
                  ]),
                )
              ])
            )
          )
        ),
        this.getBaseViews()
      ]
    }
  }
}